<!--<app-client-portal-header></app-client-portal-header>-->

<div class="content h-100 d-flex align-items-center">
  <div class="grid-cont">
    <div class="login pt-12">
      <img src="assets/login-logo.svg" width="138" height="78" alt="logo" class="mb--200 login__logo">

      <div class="block login__cont">
        <h2>Check Your Inbox!</h2>
        <img
          src="assets/check-inbox.png"
          srcset="assets/check-inbox@2x.png 2x"
          width="129"
          height="129"
          alt="logo"
          class="mt--200 login__logo"
        >
        <p class="mt--150">We just sent a password verification email to:<br><span style="font-weight: bold">{{email}}</span>
          <br>Please verify your email address and then <span (click)='logIn()' class="mt--100 text-link">log in</span></p>
      </div>
    </div>

    <app-full-client-portal-footer class="mt-8"></app-full-client-portal-footer>
  </div>
</div>

